import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { TableFormRowWrapper } from "../BuyBackFeeStyled";
import NumberInput from "web/components/form-elements/NumberInput";
import DatePicker from "web/components/DatePicker";
import Textarea from "web/components/form-elements/TextArea";
import Select from 'react-select';
import * as moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { palletTypeOptions } from "../Constants";
import { VALIDATION_SCHEMA_ADD_ITEM_FORM, getBuyBackAddNewFeeItemFormInitialValues } from "web/components/utils/buyBackFeeFormsUtils";
import { ptPlusBuyBackCreateUpdateData } from "redux/actions/adminPTPlusBuyBackFee";

const RowAddEditForm = ({
  vendorLocationList,
  buyBackFeeId,
  isEdit,
  editFeeItemData,
  editVendorData,
  setModalContent,
  setModalLink,
  toggleModal,
  setAlertType
}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const tableResponsiveDiv = document.querySelector('.table-responsive');
    if (tableResponsiveDiv) {
      tableResponsiveDiv.id = 'heightDynamicAdjustRef';
    }
  }, []);

  useEffect(() => {
    const heightDynamicAdjustRef = document.getElementById('heightDynamicAdjustRef');
    if (isDropdownOpen) {
      heightDynamicAdjustRef.scrollTop += 500
    } 
  }, [isDropdownOpen]);

  const formSubmit = async (formData) => {
    let postData = {
      id: buyBackFeeId,
      update: isEdit ? true : false,
      vendorPricing: null,
      updateReq: null,
    };

    if (!isEdit) {
      postData.vendorPricing = [
        {
          vendorLocationId: formData?.vendorLocationId,
          vendorLocationName: formData?.vendorLocationName,
          city: formData?.city,
          state: formData?.state,
          feeDetailsReq: [
            {
              pickupPalletType: formData?.pickupPalletType,
              vendorFee: parseFloat(formData?.vendorFee),
              customerFee: parseFloat(formData?.customerFee),
              rateStartDate: formData?.rateStartDate && moment(formData?.rateStartDate).format('YYYY-MM-DD'),
              rateExpirationDate: formData?.rateExpirationDate && moment(formData?.rateExpirationDate).format('YYYY-MM-DD'),
              comment: formData?.comment,
            },
          ],
        },
      ];
    } else {
      let expirationDate
      if (formData?.rateExpirationDate) {
        expirationDate = moment(formData?.rateExpirationDate).format("YYYY-MM-DD")
      } else {
        expirationDate = moment(editFeeItemData?.rateExpirationDate).format("YYYY-MM-DD")
      }
      postData.updateReq = {
        vendorLocationId: editVendorData?.vendorLocationId,
        feeId: editFeeItemData?.feeId,
        rateExpirationDate: expirationDate,
        comment: formData?.comment || editFeeItemData?.comment,
      };
    }

    try {
      let response = await dispatch(ptPlusBuyBackCreateUpdateData(postData));
      if (response && response?.success) {
        setModalContent(response?.msg || response?.data?.msg)
        setAlertType("success")
        setModalLink("");
        toggleModal();
      } else {
        if (response?.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.error?.message || response?.data?.error?.message)
          setModalLink("");
          toggleModal();
        }
      }
    } catch (error) {
      setModalContent(error || 'Something went wrong, please try again!')
      setModalLink("");
      toggleModal();
    }
  }


  return (
    <>
      <Formik
        initialValues={getBuyBackAddNewFeeItemFormInitialValues(editFeeItemData, editVendorData)}
        validationSchema={VALIDATION_SCHEMA_ADD_ITEM_FORM()}
        onSubmit={formSubmit}
      >
        {(formikProps) => {
          const { isValid, dirty, setFieldValue, values, errors, setFieldError } = formikProps;
          return (
            <Form className="form-wrapper">
              <TableFormRowWrapper>
                <div className="items-row-wrapper">
                  <tr>
                      <td>
                        <Select
                          id="vendorLocationId"
                          name="vendorLocationId"
                          value={vendorLocationList.find(option => option.value === values.vendorLocationId)}
                          onChange={(selectedOption) => {
                            setFieldValue("vendorLocationId", selectedOption.value);
                            setFieldValue("vendorLocationName", selectedOption.vendorLocationName);
                            setFieldValue("city", selectedOption.city);
                            setFieldValue("state", selectedOption.state);
                          }}
                          options={vendorLocationList}
                          placeholder="Buyback Vendor"
                          isDisabled={isEdit}
                          onMenuOpen={() => setIsDropdownOpen(true)}
                          onMenuClose={() => setIsDropdownOpen(false)}
                        />
                      </td>
                      <td>
                        <Select
                          id="pickupPalletType"
                          name="pickupPalletType"
                          value={palletTypeOptions.find(option => option.value === values.pickupPalletType)}
                          onChange={(selectedOption) => {
                            setFieldValue("pickupPalletType", selectedOption.value);
                          }}
                          options={palletTypeOptions}
                          placeholder="Pallet Type"
                          isDisabled={isEdit}
                          onMenuOpen={() => setIsDropdownOpen(true)}
                          onMenuClose={() => setIsDropdownOpen(false)}
                        />
                      </td>
                      <td>
                        <NumberInput
                          name="customerFee"
                          showErrorMessages={true}
                          decimalScale={2}
                          placeholder="$ 0.00"
                          maxLength={8}
                          onChangeHandler={(val) => {
                            setFieldValue("customerFee", val)
                          }}
                          disabled={isEdit}
                        />
                      </td>
                      <td>
                        <NumberInput
                          name="vendorFee"
                          showErrorMessages={true}
                          decimalScale={2}
                          placeholder="$ 0.00"
                          maxLength={8}
                          onChangeHandler={(val) => {
                            setFieldValue("vendorFee", val)
                          }}
                          disabled={isEdit}
                        />
                      </td>
                      <td>
                        <DatePicker
                          name="rateStartDate"
                          maxDOBirth={values.rateExpirationDate}
                          value={values.rateStartDate}
                          type="buyBackFeeForm"
                          callBackFun={(date, value) => {
                            setFieldValue("rateStartDate", moment(date).format("MM/DD/YYYY"))
                          }}
                          disabled={isEdit}
                        />
                        {errors && errors.rateStartDate && (
                          <p className="error-message">{errors.rateStartDate}</p>
                        )}
                      </td>
                      <td>
                        <DatePicker
                          name="rateExpirationDate"
                          minDOBirth={values.rateStartDate}
                          value={values.rateExpirationDate}
                          type="buyBackFeeForm"
                          callBackFun={(date, value) => {
                            setFieldValue("rateExpirationDate", moment(date).format("MM/DD/YYYY"))
                          }}
                        />
                        {errors && errors.rateExpirationDate && (
                          <p className="error-message">{errors.rateExpirationDate}</p>
                        )}
                      </td>
                      <td>
                        <Textarea
                          name="comment"
                          showErrorMessages={true}
                          rows={1}
                          onChange={(val) => {
                            setFieldValue("comment", val)
                          }}
                        />
                      </td>
                      <td>
                        <button
                          className="save-item"
                          type="app-green-button"
                          handleClick={() => formSubmit(formikProps)}
                          disabled={!(isValid && dirty)}
                        >{isEdit ? "Update" : "Submit"}</button>
                      </td>
                  </tr>
                </div>

              </TableFormRowWrapper>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default RowAddEditForm;
